<template>
  <layout>
    <div slot="content">
      <i-card title="应用列表">
        <div slot="right-menu">
          <el-button class="btn-wechat-auth" size="small" @click="goAuthorizeMiniApp">
            <svg class="wechat-icon" viewBox="0 0 1024 1024" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 8.6 17.8l-1.2 49.8c-.5 19.1 17.5 32.6 34.6 24.7l66.9-30.9a21.8 21.8 0 0 1 15.9-.8c26.5 7.8 54.9 12 84.2 12 5.9 0 11.7-.2 17.5-.5-5.5-18.5-8.5-37.9-8.5-57.9 0-121.2 106.6-219.5 246.1-219.5zM465.2 300.9a40.5 40.5 0 1 1 0 81 40.5 40.5 0 0 1 0-81zm-175.1 0a40.5 40.5 0 1 1 0 81 40.5 40.5 0 0 1 0-81zM960 629.5c0-124.1-123.5-225.1-276.1-225.1-152.6 0-276.1 101-276.1 225.1s123.5 225.1 276.1 225.1c24.5 0 48.2-3.1 70.6-8.8a18.3 18.3 0 0 1 13.3.7l55.9 25.8c14.3 6.6 29.4-4.7 29-20.6l-1-41.6a18 18 0 0 1 7.2-14.9C916.4 758.4 960 697.8 960 629.5zM600.2 553.9a33.8 33.8 0 1 1 0 67.6 33.8 33.8 0 0 1 0-67.6zm146.3 0a33.8 33.8 0 1 1 0 67.6 33.8 33.8 0 0 1 0-67.6z"/>
            </svg>
            授权微信小程序
          </el-button>
        </div>
        <div slot="content">
          <div class="search-bar">
            <el-form :inline="true" :model="filter" @submit.native.prevent>
              <el-form-item label="AppID">
                <el-input v-model="filter.app_id" placeholder="请输入 AppID" clearable style="width: 220px"></el-input>
              </el-form-item>
              <el-form-item label="小程序名称">
                <el-input v-model="filter.app_name" placeholder="请输入小程序名称" clearable style="width: 220px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchList">搜索</el-button>
                <el-button @click="resetFilter">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="pageList" :border="true">
            <el-table-column prop="title" label="应用图标" width="100" fixed="left">
              <template slot-scope="scope" v-if="scope.row.logo">
                <img :src="scope.row.logo" width="70" height="70"
                     style="border-radius: 200px;background: #eee;border:1px solid #eee">
              </template>
            </el-table-column>
            <el-table-column prop="app_name" width="280" label="应用名称" fixed="left">
              <template slot-scope="scope">
                <p>应用名称:{{ scope.row.app_name }}</p>
                <p>APP_ID:{{ scope.row.app_id }}</p>
                <p>公司主体:{{ scope.row.company_name || '未填写' }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="platform_name" label="应用类型" width="120"></el-table-column>
            <el-table-column label="支付商户" min-width="160">
              <template slot-scope="scope">
                <template v-if="scope.row.pay_merchant_id">
                  <p class="pay-merchant-cell-name">{{ scope.row.pay_merchant_name || '-' }}</p>
                  <p class="pay-merchant-cell-id">微信商户号: {{ scope.row.pay_merchant_mch_id || '-' }}</p>
                </template>
                <span v-else class="pay-merchant-cell-empty">未绑定</span>
              </template>
            </el-table-column>
            <el-table-column prop="code_status_name" label="代码状态" width="100"></el-table-column>
            <el-table-column prop="code_audit_time" label="最近提审时间" width="200"></el-table-column>
            <el-table-column label="审核状态" width="200">
              <template slot-scope="scope">
                {{ scope.row.code_audit_status_name }}
                <p v-html="scope.row.code_audit_reason" style="font-size: 12px;color: red"></p>
              </template>
            </el-table-column>
            <el-table-column label="版本信息">
              <template slot-scope="scope">
                <p>版本号:{{ scope.row.user_version }}</p>
                <p>代码模板ID:{{ scope.row.template_id }}</p>
                <p>描述:{{ scope.row.user_desc }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
              <div class="app-ops" slot-scope="scope">
                <el-button type="text" size="mini" @click="showEdit(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" @click="showPageView(scope.row)">预览</el-button>
                <el-dropdown trigger="click" @command="(cmd) => handleAppCommand(cmd, scope.row)">
                  <el-button type="text" size="mini">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="deploy">提交代码</el-dropdown-item>
                    <el-dropdown-item command="verify">提交审核</el-dropdown-item>
                    <el-dropdown-item command="post">发布</el-dropdown-item>
                    <el-dropdown-item command="privacy">设置隐私</el-dropdown-item>
                    <el-dropdown-item command="delete" divided>
                      <span class="app-ops-danger">删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </i-card>
      <div class="page-wrap">
        <el-pagination background :page-size="pageInfo.per_page" :current-page="pageInfo.current_page"
                       layout="prev, pager, next" @current-change="changePage" :total="pageInfo.total"/>
      </div>
      <!--应用配置开始-->
      <el-dialog title="应用配置" :visible.sync="showConfig" width="50%">
        <el-form ref="form" :model="config" label-width="100px">
          <el-form-item label="app_id">
            <el-input v-model="currApp.app_id" disabled></el-input>
          </el-form-item>
          <el-form-item label="应用类型">
            <el-input v-model="currApp.platform_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="应用名称">
            <el-input v-model="config.app_name" placeholder="请输入应用名称"></el-input>
          </el-form-item>
          <el-form-item label="应用开关">
            <template>
              <el-radio v-model="config.app_switch" label="1">开启</el-radio>
              <el-radio v-model="config.app_switch" label="2">关闭</el-radio>
            </template>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 应用关闭后用户打开将无法进行任何操作</div>
          </el-form-item>
          <el-form-item label="底部菜单">
            <template>
              <el-radio v-model="config.bottom_menu" label="1">开启</el-radio>
              <el-radio v-model="config.bottom_menu" label="2">关闭</el-radio>
            </template>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 关闭后小程序自带底部菜单将不会展示</div>
          </el-form-item>
          <el-form-item label="直播开关">
            <template>
              <el-radio v-model="config.live" label="1">开启</el-radio>
              <el-radio v-model="config.live" label="2">关闭</el-radio>
            </template>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 关闭后将用产品列表替代</div>
          </el-form-item>
          <el-form-item label="应用标题">
            <el-input v-model="config.title"></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 该标题在应用上方标题显示，不同于应用名称</div>
          </el-form-item>
          <el-form-item label="首页公告">
            <el-input v-model="config.notice"></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/>可在首页展示的公告</div>
          </el-form-item>
          <el-form-item label="客服电话">
            <el-input v-model="config.service_phone"></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 每个应用可以自定义不同的客服电话,置空则使用全局设置</div>
          </el-form-item>
          <el-form-item label="公司主体">
            <el-input v-model="config.company_name"></el-input>
          </el-form-item>
          <el-form-item label="支付商户">
            <el-select v-model="config.pay_merchant_id" placeholder="请选择支付商户" clearable filterable style="width: 100%">
              <el-option v-for="item in payMerchantOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 绑定后，用户发起支付时使用该商户的配置</div>
          </el-form-item>
          <el-form-item label="分享标题">
            <el-input v-model="config.share_title" placeholder="留空则使用小程序默认名称" maxlength="100" show-word-limit clearable></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 用户转发小程序时展示的标题，留空则使用微信默认</div>
          </el-form-item>
          <el-form-item label="分享页面">
            <el-select v-model="config.share_path" placeholder="留空则分享当前页面" clearable filterable style="width: 100%">
              <el-option v-for="item in pathList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 用户转发时打开的页面路径，留空则分享用户当前所在页面</div>
          </el-form-item>
          <el-form-item label="分享图片">
            <el-upload
              class="share-image-uploader"
              name="image"
              :action="uploadImageUrl"
              :data="uploadPostData"
              :show-file-list="false"
              :on-success="handleShareImageSuccess"
              :before-upload="beforeShareImageUpload"
              accept="image/*"
            >
              <img v-if="config.share_image" :src="config.share_image" class="share-image-preview">
              <i v-else class="el-icon-plus share-image-uploader-icon"></i>
            </el-upload>
            <div style="margin-top:5px;" v-if="config.share_image">
              <el-button size="mini" type="danger" @click="config.share_image = ''">删除图片</el-button>
            </div>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 用户转发小程序时展示的缩略图，建议尺寸 500x400，留空则使用微信默认截图</div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showConfig = false">取 消</el-button>
          <el-button type="primary" v-loading="loading" @click="postEdit">确 定</el-button>
        </div>
      </el-dialog>
      <!--发布代码-->
      <el-dialog title="代码发布" :visible.sync="showDeployCode" width="40%">
        <el-form ref="form" :model="deployCode" label-width="100px">
          <el-form-item label="AppId">
            <el-input v-model="deployCode.app_id" disabled></el-input>
          </el-form-item>
          <el-form-item label="应用名称">
            <el-input v-model="deployCode.app_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="代码模板id" required>
            <el-input v-model="deployCode.code_tpl_id"></el-input>
          </el-form-item>
          <el-form-item label="版本号" required>
            <el-input v-model="deployCode.user_version"></el-input>
          </el-form-item>
          <el-form-item label="版本说明" required>
            <el-input v-model="deployCode.user_desc"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showDeployCode = false">取 消</el-button>
          <el-button type="primary" v-loading="loading" @click="doDeployCode">确 定</el-button>
        </div>
      </el-dialog>
      <!--页面路径-->
      <el-dialog title="页面预览" :visible.sync="showPage" width="40%">
        <el-form ref="form" :model="deployCode" label-width="100px">
          <el-form-item label="页面选择">
            <el-select v-model="currPagePath" placeholder="请选择" filterable style="width: 80%">
              <el-option v-for="item in pathList" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="页面二维码">
            <div style="background: #eee;display: inline-block;padding: 15px 15px 0 15px;border-radius: 10px;">
              <img
                :src="'http://weapp.migumaotrip.com/api/apps/qr_code?app_id='+currApp.app_id+'&path='+currPagePath+'&api_token='+apiToken"
                width="200" height="200">
            </div>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 该二维码为体验版，需要有体验权限</div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showPage = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import httpConfig from '@/api/config'

function adminApiAbsoluteUrl(apiPath) {
  const proto = httpConfig.isHttps ? 'https://' : 'http://'
  return proto + httpConfig.apiDomain + apiPath
}

export default {
  name: "app_list",
  data() {
    return {
      pageUrl: "appsList",
      pageList: [],
      pageInfo: {
        per_page: 10,
        current_page: 1,
        total: 0,
      },
      filter: {
        app_id: '',
        app_name: ''
      },
      loading: false,
      showConfig: false,
      currApp: {},
      config: {},
      showDeployCode: false,
      deployCode: {
        code_tpl_id: '',
        user_version: '',
        user_desc: '',
        app_id: '',
        app_name: '',
        company_name: ''
      },
      showPage: false,
      pathList: [],
      currPagePath: "",
      apiToken: '',
      payMerchantOptions: []
    }
  },
  computed: {
    uploadImageUrl: function () {
      return adminApiAbsoluteUrl('/api/common/upload_image')
    },
    uploadPostData: function () {
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        return user && user.api_token ? { api_token: user.api_token } : {}
      } catch (_e) {
        return {}
      }
    }
  },
  methods: {
    goAuthorizeMiniApp: function () {
      window.open('https://open.weixin.migumaotrip.com/', '_blank');
    },
    // 获取支付商户选项
    getPayMerchantOptions: function () {
      this.$http.request('payMerchantOptions').then(res => {
        this.payMerchantOptions = res.data;
      });
    },
    getList: function () {
      this.$http.request(this.pageUrl, {filter: this.filter, page: this.pageInfo.current_page}).then(res => {
        if (!res || !res.data) {
          return;
        }
        this.pageList = res.data;
        this.pageInfo = res.meta;
      });
    },
    searchList: function () {
      this.pageInfo.current_page = 1;
      this.getList();
    },
    resetFilter: function () {
      this.filter = {
        app_id: '',
        app_name: ''
      };
      this.pageInfo.current_page = 1;
      this.getList();
    },
    refreshCurrentPage: function () {
      this.getList();
    },
    postEdit: function () {
      this.loading = true;
      this.$http.request('setAppConfig', {app_id: this.currApp.app_id, config: this.config}).then(res => {
        this.loading = false;
        if (res && res.status === 'success') {
          this.showConfig = false;
          this.refreshCurrentPage();
          this.$message({
            message: res.message,
            type: 'success',
          });
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    getConfig: function () {
      this.$http.request('getAppConfig', {app_id: this.currApp.app_id}).then(res => {
        if (res.data.config && Object.keys(res.data.config).length > 0) {
          this.config = res.data.config;
        } else {
          this.config = {};
        }
        // 如果app_name不在config中，从currApp获取
        if (!this.config.app_name) {
          this.config.app_name = this.currApp.app_name;
        }
        if (this.config.share_title === undefined || this.config.share_title === null) {
          this.$set(this.config, 'share_title', '');
        }
        if (this.config.share_path === undefined || this.config.share_path === null) {
          this.$set(this.config, 'share_path', '');
        }
        if (this.config.share_image === undefined || this.config.share_image === null) {
          this.$set(this.config, 'share_image', '');
        }
      });
    },
    beforeShareImageUpload: function (file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return false;
      }
      return true;
    },
    handleShareImageSuccess: function (response, file) {
      if (response.status === 'success' && response.data && response.data.file_url) {
        this.config.share_image = response.data.file_url;
        this.$message.success('图片上传成功');
      } else {
        this.$message.error(response.message || '图片上传失败');
      }
    },
    getAllPage: function () {
      this.$http.request('allPagePath', {app_id: this.currApp.app_id}).then(res => {
        this.pathList = res.data.page_list;
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getList();
    },
    handleAppCommand: function (command, row) {
      if (command === 'deploy') {
        this.showDeployCodeModal(row.app_id, row.app_name);
        return;
      }
      if (command === 'verify') {
        this.postVerify(row.app_id);
        return;
      }
      if (command === 'post') {
        this.postCode(row.app_id);
        return;
      }
      if (command === 'privacy') {
        this.setPrivacy(row.app_id, row.app_name);
        return;
      }
      if (command === 'delete') {
        this.delApp(row.app_id);
      }
    },
    showEdit: function (appInfo) {
      this.currApp = appInfo;
      this.pathList = [];
      this.config = {};
      this.showConfig = true;
      this.getConfig();
      this.getAllPage();
    },
    showPageView: function (appInfo) {
      this.pathList = [];
      this.currPagePath = "";
      this.currApp = appInfo;
      this.showPage = true;
      this.getAllPage();
    },
    doDeployCode: function () {
      this.loading = true;
      this.$http.request('deployCode', this.deployCode).then(res => {
        this.loading = false;
        if (res && res.status === 'success') {
          this.showDeployCode = false;
          this.refreshCurrentPage();
          this.$message({
            message: res.message,
            type: 'success',
          });
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    showDeployCodeModal: function (appId, appName) {
      this.showDeployCode = true;
      this.deployCode.app_id = appId;
      this.deployCode.app_name = appName;
    },
    postCode: function (appId) {
      this.$confirm('确定全量发布吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('postCode', {app_id: appId}).then(res => {
          if (res && res.status === 'success') {
            this.$message({
              type: res.status,
              message: res.message
            });
            this.refreshCurrentPage();
          }
        });
      });
    },
    postVerify: function (appId) {
      this.$confirm('确定提交审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('verifyCode', {app_id: appId}).then(res => {
          if (res && res.status === 'success') {
            this.$message({
              type: res.status,
              message: res.message
            });
            this.refreshCurrentPage();
          }
        });
      });
    },

    setPrivacy: function (appId, appName) {
      this.$confirm('确定为「' + (appName || appId) + '」设置隐私协议吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.request('setPrivacy', {app_id: appId}).then(res => {
          this.loading = false;
          if (res && res.status === 'success') {
            this.$message({
              type: 'success',
              message: res.message
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      });
    },

    delApp: function (appId) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('delApp', {app_id: appId}).then(res => {
          if (res && res.status === 'success') {
            this.$message({
              type: res.status,
              message: res.message
            });
            this.refreshCurrentPage();
          }
        });
      });
    }
  },
  created: function () {
    this.getList();
    this.getPayMerchantOptions();
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.apiToken = user.api_token;
    }
  }
}
</script>

<style scoped>
.search-bar {
  margin-bottom: 16px;
}
.btn-wechat-auth {
  background-color: #07c160;
  border-color: #07c160;
  color: #fff;
}
.btn-wechat-auth:hover,
.btn-wechat-auth:focus {
  background-color: #06ad56;
  border-color: #06ad56;
  color: #fff;
}
.btn-wechat-auth:active {
  background-color: #059a4c;
  border-color: #059a4c;
  color: #fff;
}
.btn-wechat-auth .wechat-icon {
  margin-right: 4px;
  vertical-align: -3px;
}
.app-ops {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  line-height: 1;
}
.app-ops .el-button,
.app-ops >>> .el-dropdown,
.app-ops >>> .el-dropdown .el-button {
  display: inline-flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  padding: 0 4px;
  margin: 0;
  vertical-align: middle;
}
.app-ops >>> .el-dropdown .el-icon--right {
  margin-left: 2px;
  line-height: 1;
}
.app-ops-danger {
  color: #F56C6C;
}
.pay-merchant-cell-name {
  margin: 0;
  color: #303133;
  line-height: 1.4;
}
.pay-merchant-cell-id {
  margin: 4px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.3;
}
.pay-merchant-cell-empty {
  color: #c0c4cc;
}
.share-image-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.share-image-uploader >>> .el-upload:hover {
  border-color: #409EFF;
}
.share-image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  display: block;
}
.share-image-preview {
  width: 120px;
  height: 120px;
  display: block;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/apps/app_list.vue